import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Card,
  Typography
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import {
  getCatalogStoreCodesAPI,
  getSubscriptionCouponCodesApi
} from 'api';
import SubscriptionCouponCodeForm from './SubscriptionCouponCodeForm';
import SubscriptionCouponCodesList from './SubscriptionCouponCodesList';


const StoreSubscriptionCouponCodes = () => {
  const dispatch = useDispatch();
  const [addNewCode, toggleAddNewCode] = useState(false);
  const {
    catalogStoreCodes,
    subscriptionCouponCodes,
    loadingCouponCodes
  } = useSelector((state: IReduxState) => state.admin);

  useEffect(() => {
    if (!catalogStoreCodes.length) {
      getCatalogStoreCodesAPI({dispatch});
    }

    if (!subscriptionCouponCodes.length) {
      getSubscriptionCouponCodesApi({dispatch});
    }
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <Typography variant="h3" className="mb-8">Access Codes</Typography>
      {addNewCode ?
        <Card
          className="p-8 mx-auto max-w-600"
          elevation={25}
        >
          <Typography variant="h6" className="mb-8">
            Please fill in the following details for new access code configurations.
          </Typography>
          <SubscriptionCouponCodeForm
            catalogStoreCodes={catalogStoreCodes}
            toggleCouponCodeForm={toggleAddNewCode}
          />
        </Card>
        :
        <>
          <Button
            color="primary"
            variant="contained"
            className="mb-5"
            onClick={() => toggleAddNewCode(!addNewCode)}
          >
            Add New Access Code
          </Button>
          <Card
            className="p-8 mb-4"
            elevation={25}
          >
            <SubscriptionCouponCodesList
              codes={subscriptionCouponCodes}
              catalogStoreCodes={catalogStoreCodes}
            />
          </Card>
        </>
      }
      <BackdropCircular loading={loadingCouponCodes} />
    </div>
  );
};

export default StoreSubscriptionCouponCodes;
